import { mapToCanActivate, Routes } from '@angular/router';
import { userGuard } from '@core/guards';
import { strainRoutes } from '@features/strains/strain.routes';
import { AuthGuard } from '@auth0/auth0-angular';
import { strainDetailsRoutes } from '@features/strain-details/strain-details.routes';
import { accountSettingsRoutes } from '@features/account-settings/account-settings.routes';
import { suppliesRoutes } from '@features/supplies/supplies.routes';
import { ordersRoutes } from '@features/orders/orders.routes';
import { orderSetupRoutes } from '@features/order-setup/order-setup.routes';
import { orderDetailsRoutes, orderDetailsSharedRoutes } from '@features/order-details/order-details.routes';
import { centralShippingRoutes } from '@features/central-shipping/central-shipping.routes';
import { dashboardRoutes } from '@features/dashboard/dashboard.routes';
import { AppRouterHelper } from '@core/helpers/app-router.helper';
import { checkmateRoutes } from '@features/checkmate/checkmate.routes';
import { orderRetestRoutes } from '@features/order-retest/order-retest.routes';

export const routes: Routes = [
    {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
    },
    {
        path: 'dashboard',
        canActivate: mapToCanActivate([AuthGuard]),
        children: dashboardRoutes,
    },
    {
        path: 'strains',
        canActivate: mapToCanActivate([AuthGuard]),
        children: strainRoutes,
    },
    {
        path: 'strain-details',
        canActivate: mapToCanActivate([AuthGuard]),
        children: strainDetailsRoutes,
    },
    {
        path: 'account',
        canActivate: mapToCanActivate([AuthGuard]),
        children: accountSettingsRoutes,
    },
    {
        path: 'supplies',
        canActivate: mapToCanActivate([AuthGuard]),
        children: suppliesRoutes,
    },
    {
        path: 'orders',
        canActivate: mapToCanActivate([AuthGuard]),
        children: ordersRoutes,
    },
    {
        path: 'order-details',
        canActivate: mapToCanActivate([AuthGuard]),
        children: orderDetailsRoutes,
    },
    {
        path: 'order-details-shared',
        children: orderDetailsSharedRoutes,
    },
    {
        path: 'order-results-redirect',
        loadComponent: () =>
            import('./shared/components/retired-order-export/retired-order-export.component').then(
                mod => mod.RetiredOrderExportComponent
            ),
        title: 'QuickOrder - Results Redirect',
        data: {
            breadcrumb: null,
        },
    },
    {
        path: 'order-setup',
        canActivate: mapToCanActivate([AuthGuard]),
        children: orderSetupRoutes,
    },
    {
        path: 'order-retest',
        canActivate: mapToCanActivate([AuthGuard]),
        children: orderRetestRoutes,
    },
    {
        path: 'checkmate',
        canActivate: mapToCanActivate([AuthGuard]),
        children: checkmateRoutes,
    },
    {
        path: 'central-shipping',
        canActivate: mapToCanActivate([AuthGuard]),
        children: centralShippingRoutes,
    },
    {
        path: 'error',
        canActivate: [userGuard],
        loadComponent: () =>
            import('./shared/components/error-page/error-page.component').then(mod => mod.ErrorPageComponent),
        data: {
            breadcrumb: null,
        },
    },
    {
        path: 'error-current-user',
        loadComponent: () =>
            import('./shared/components/error-page/error-page.component').then(mod => mod.ErrorPageComponent),
        data: {
            breadcrumb: null,
        },
    },
    {
        path: 'unauthorized',
        loadComponent: () =>
            import('./shared/components/unauthorized-page/unauthorized-page.component').then(
                mod => mod.UnauthorizedPageComponent
            ),
        data: {
            breadcrumb: null,
        },
    },

    ...AppRouterHelper.getLegacyUrls(),

    {
        path: '**',
        redirectTo: 'dashboard',
        pathMatch: 'full',
    },
];
